// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ userRole, username, handleLogout, setModalOpen, setRegisterModalOpen }) => {
  const [showProducts, setShowProducts] = useState(false);

  return (
    <header className="is-header">
      <div className="header-container">
        {/* Bloque Izquierdo: Logo */}
        <div className="logo-area">
          <Link to="/" className="logo-link">
            <img src="/images/logox2.png" alt="InovateSport Logo" className="logo" />
          </Link>
        </div>

        {/* Bloque Central: Navegación e Iconos */}
        <nav className="header-nav-center">
  
          

          <div className="nav-shortcuts-group">
            <Link to="/Inscripciones" className="nav-pill-link" title="Inscripciones">
              Inscripciones
            </Link>
            <Link to="/Cronometraje" className="nav-pill-link" title="Cronometraje">
              Cronometraje
            </Link>
            <Link to="/Asesoramiento" className="nav-pill-link" title="Asesoramiento">
              Asesoramiento
            </Link>
            <Link to="/Merchandising" className="nav-pill-link" title="Merchandising">
            Souvenirs & Identidad
            </Link>
          </div>
        </nav>
        
        {/* Bloque Derecho: Buscador y Acciones de Cuenta */}
        <div className="header-right-side">

          
          <div className="header-auth-actions">
            {username ? (
              <div className="user-logged-wrapper">
                <span className="user-greeting">👋 {username}</span>
                {userRole === 'Superadministrador' && (
                  <button className="btn-header-action btn-admin-register" onClick={() => setRegisterModalOpen(true)}>
                    ➕ Registrar
                  </button>
                )}
                <button className="btn-header-action btn-logout" onClick={handleLogout}>
                  Salir
                </button>
              </div>
            ) : (
              <button className="btn-header-action btn-login-trigger" onClick={() => setModalOpen(true)}>
                Ingresar
              </button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;